/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListUserDefaultBudgetEventsRequest = {
  orgId?: string | undefined;
};

export const ListUserDefaultBudgetEventsType = {
  ThresholdAlert: "threshold_alert",
  Blocked: "blocked",
} as const;
export type ListUserDefaultBudgetEventsType = ClosedEnum<
  typeof ListUserDefaultBudgetEventsType
>;

export type ListUserDefaultBudgetEventsData = {
  id: string;
  budgetId: string;
  type: ListUserDefaultBudgetEventsType;
  pct: number | null;
  periodKey: string;
  targetId: string;
  spendSnapshot: number;
  limitSnapshot: number;
  createdAt: string;
};

/**
 * OK
 */
export type ListUserDefaultBudgetEventsResponseBody = {
  object: "list";
  data: Array<ListUserDefaultBudgetEventsData>;
};

/** @internal */
export const ListUserDefaultBudgetEventsRequest$inboundSchema: z.ZodType<
  ListUserDefaultBudgetEventsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  org_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
  });
});
/** @internal */
export type ListUserDefaultBudgetEventsRequest$Outbound = {
  org_id?: string | undefined;
};

/** @internal */
export const ListUserDefaultBudgetEventsRequest$outboundSchema: z.ZodType<
  ListUserDefaultBudgetEventsRequest$Outbound,
  z.ZodTypeDef,
  ListUserDefaultBudgetEventsRequest
> = z.object({
  orgId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
  });
});

export function listUserDefaultBudgetEventsRequestToJSON(
  listUserDefaultBudgetEventsRequest: ListUserDefaultBudgetEventsRequest,
): string {
  return JSON.stringify(
    ListUserDefaultBudgetEventsRequest$outboundSchema.parse(
      listUserDefaultBudgetEventsRequest,
    ),
  );
}
export function listUserDefaultBudgetEventsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListUserDefaultBudgetEventsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListUserDefaultBudgetEventsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserDefaultBudgetEventsRequest' from JSON`,
  );
}

/** @internal */
export const ListUserDefaultBudgetEventsType$inboundSchema: z.ZodNativeEnum<
  typeof ListUserDefaultBudgetEventsType
> = z.nativeEnum(ListUserDefaultBudgetEventsType);
/** @internal */
export const ListUserDefaultBudgetEventsType$outboundSchema: z.ZodNativeEnum<
  typeof ListUserDefaultBudgetEventsType
> = ListUserDefaultBudgetEventsType$inboundSchema;

/** @internal */
export const ListUserDefaultBudgetEventsData$inboundSchema: z.ZodType<
  ListUserDefaultBudgetEventsData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  budget_id: z.string(),
  type: ListUserDefaultBudgetEventsType$inboundSchema,
  pct: z.nullable(z.number()),
  period_key: z.string(),
  target_id: z.string(),
  spend_snapshot: z.number(),
  limit_snapshot: z.number(),
  created_at: z.string(),
}).transform((v) => {
  return remap$(v, {
    "budget_id": "budgetId",
    "period_key": "periodKey",
    "target_id": "targetId",
    "spend_snapshot": "spendSnapshot",
    "limit_snapshot": "limitSnapshot",
    "created_at": "createdAt",
  });
});
/** @internal */
export type ListUserDefaultBudgetEventsData$Outbound = {
  id: string;
  budget_id: string;
  type: string;
  pct: number | null;
  period_key: string;
  target_id: string;
  spend_snapshot: number;
  limit_snapshot: number;
  created_at: string;
};

/** @internal */
export const ListUserDefaultBudgetEventsData$outboundSchema: z.ZodType<
  ListUserDefaultBudgetEventsData$Outbound,
  z.ZodTypeDef,
  ListUserDefaultBudgetEventsData
> = z.object({
  id: z.string(),
  budgetId: z.string(),
  type: ListUserDefaultBudgetEventsType$outboundSchema,
  pct: z.nullable(z.number()),
  periodKey: z.string(),
  targetId: z.string(),
  spendSnapshot: z.number(),
  limitSnapshot: z.number(),
  createdAt: z.string(),
}).transform((v) => {
  return remap$(v, {
    budgetId: "budget_id",
    periodKey: "period_key",
    targetId: "target_id",
    spendSnapshot: "spend_snapshot",
    limitSnapshot: "limit_snapshot",
    createdAt: "created_at",
  });
});

export function listUserDefaultBudgetEventsDataToJSON(
  listUserDefaultBudgetEventsData: ListUserDefaultBudgetEventsData,
): string {
  return JSON.stringify(
    ListUserDefaultBudgetEventsData$outboundSchema.parse(
      listUserDefaultBudgetEventsData,
    ),
  );
}
export function listUserDefaultBudgetEventsDataFromJSON(
  jsonString: string,
): SafeParseResult<ListUserDefaultBudgetEventsData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserDefaultBudgetEventsData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserDefaultBudgetEventsData' from JSON`,
  );
}

/** @internal */
export const ListUserDefaultBudgetEventsResponseBody$inboundSchema: z.ZodType<
  ListUserDefaultBudgetEventsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(z.lazy(() => ListUserDefaultBudgetEventsData$inboundSchema)),
});
/** @internal */
export type ListUserDefaultBudgetEventsResponseBody$Outbound = {
  object: "list";
  data: Array<ListUserDefaultBudgetEventsData$Outbound>;
};

/** @internal */
export const ListUserDefaultBudgetEventsResponseBody$outboundSchema: z.ZodType<
  ListUserDefaultBudgetEventsResponseBody$Outbound,
  z.ZodTypeDef,
  ListUserDefaultBudgetEventsResponseBody
> = z.object({
  object: z.literal("list"),
  data: z.array(z.lazy(() => ListUserDefaultBudgetEventsData$outboundSchema)),
});

export function listUserDefaultBudgetEventsResponseBodyToJSON(
  listUserDefaultBudgetEventsResponseBody:
    ListUserDefaultBudgetEventsResponseBody,
): string {
  return JSON.stringify(
    ListUserDefaultBudgetEventsResponseBody$outboundSchema.parse(
      listUserDefaultBudgetEventsResponseBody,
    ),
  );
}
export function listUserDefaultBudgetEventsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  ListUserDefaultBudgetEventsResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListUserDefaultBudgetEventsResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListUserDefaultBudgetEventsResponseBody' from JSON`,
  );
}
